import React from "react"
import { Col, Row } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { InvoiceDto } from "../../../state/invoice/models"
import Proposal from "../../../state/proposal/Proposal"


type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceCreatedFromWixEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)

    const renderMessage = () => {
        switch (type) {
        case "main":
            return <FormattedMessage
                id="invoice.analytics.events.exported.wix.text"
                defaultMessage="Invoice {identifier} was imported from Wix order"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        default:
            return <></>
        }
    }

    return (
        <Row>

            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>
            <Col className="d-flex align-items-center flex-wrap">
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.WIX, 70)}
                    </a>
                </div>
                {Url &&
                <div>
                    <p className={"mb-0"}>
                        <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                            <FormattedMessage
                                id="invoice.analytics.events.exported.wix.open"
                                defaultMessage="Open order in Wix"
                            />
                        </a>
                    </p>
                </div>
                }
            </Col>

        </Row>
    )
}


export default InvoiceCreatedFromWixEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-wix.component.tsx